import { keyBy } from 'lodash';

export const remapClients = (clients) => {
  return keyBy(clients, 'id');
};

export const remapUsers = (users) => {
  return keyBy(users, 'id');
};
